import axios from "axios";
import localStorage from "redux-persist/es/storage";

import { LOGIN_PATH, REFRESH_PATH, TOKEN_NAME } from "./constants";
import { AuthRefreshTokenResponseService } from "../../services/auth/AuthenticationServices.type";

export async function getTokensLocalStorage() {
  const LavorisStorage = await localStorage.getItem("persist:lavoris");
  const { auth } = LavorisStorage ? JSON.parse(LavorisStorage) : null;
  const tokens = auth ? JSON.parse(auth) : null;
  return tokens;
}

export async function removeTokensLocalStorage() {
  window.localStorage.clear();
}

export const getNewTokensUsingRefresh = async () => {
  const tokens = getTokens();
  return axios.request({
    method: "post",
    url: `${process.env.REACT_APP_API_LAVORIS_URL}${process.env.REACT_APP_API_LAVORIS_VERSION}/auth/refresh`,
    headers: { Authorization: `Bearer ${tokens?.refresh_token}` },
  });
};

export const reTryRequest = async (
  errorConfig: any,
  newHeaders: any,
): Promise<any> => {
  errorConfig.headers = newHeaders;

  const axiosRequest = await axios.request(errorConfig);

  return axiosRequest.data;
};

export const getTokens = (): AuthRefreshTokenResponseService | null => {
  const tokensRaw = window.localStorage.getItem(TOKEN_NAME);
  return tokensRaw && JSON.parse(tokensRaw);
};

export const setNewTokens = (
  newValues: AuthRefreshTokenResponseService,
): void => {
  const tokensStringify = JSON.stringify(newValues);

  window.localStorage.setItem(TOKEN_NAME, tokensStringify);
};

export const clearStorageAndRedirectToLogin = async (
  error: any,
): Promise<void> => {
  const errorIsUnauthorized =
    error.response.data.statusCode === 401 &&
    error.response.data.path === `${REFRESH_PATH}`;

  if (!errorIsUnauthorized) return Promise.reject(error);

  await removeTokensLocalStorage();

  window.location.replace(window.location.origin);
};

export const shouldNotRetry = (errorData: any) => {
  const errorIsNotUnauthorized =
    errorData.statusCode === 401 && errorData.path !== `${REFRESH_PATH}`;

  const errorIsLogin = errorData.path === `${LOGIN_PATH}`;

  return !errorIsNotUnauthorized || errorIsLogin;
};
